/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import Loading from './Loading';

export function LoginCallbackLoading() {
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    // With okta, if the url is like /login/callback?code=1234, then do nothing
    // If the url is like /login/callback with parameters, then redirect to /
    if (Object.keys(params).length > 0 || window.location.search.length > 0) {
      console.log('LoginCallbackLoading', params, window.location.search);
      return; // do nothing
    }
    const timeout = setTimeout(() => {
      console.log(
        'LoginCallbackLoading: redirecting to / because /login/callback has no parameters:',
        params,
        window.location.href,
        window.location.search
      );
      navigate('/');
    }, 1000);

    return () => {
      // cancel the timeout in the cleanup function
      console.log('LoginCallbackLoading: clearing timeout');
      clearTimeout(timeout);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);
  return <Loading />;
}
